/**
 * @generated SignedSource<<ae11f22f425cdfb016e01dfdaa5ab42f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoDueDateModal_scheduleTodo_Mutation$variables = {
  date?: DateString  | null;
  id: string;
};
export type TodoDueDateModal_scheduleTodo_Mutation$data = {
  readonly scheduleTodo: {
    readonly todoUpdated: {
      readonly " $fragmentSpreads": FragmentRefs<"TodoDueDate_todo">;
    };
  } | null;
};
export type TodoDueDateModal_scheduleTodo_Mutation = {
  response: TodoDueDateModal_scheduleTodo_Mutation$data;
  variables: TodoDueDateModal_scheduleTodo_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "date"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "date",
        "variableName": "date"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoDueDateModal_scheduleTodo_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TodosScheduleMutationPayload",
        "kind": "LinkedField",
        "name": "scheduleTodo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "todoUpdated",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TodoDueDate_todo"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TodoDueDateModal_scheduleTodo_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TodosScheduleMutationPayload",
        "kind": "LinkedField",
        "name": "scheduleTodo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "todoUpdated",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dueDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AuthorizationResult",
                "kind": "LinkedField",
                "name": "canSchedule",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "value",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7c132c965baa5dd12dccfbd199e62eab",
    "id": null,
    "metadata": {},
    "name": "TodoDueDateModal_scheduleTodo_Mutation",
    "operationKind": "mutation",
    "text": "mutation TodoDueDateModal_scheduleTodo_Mutation(\n  $id: ID!\n  $date: Date\n) {\n  scheduleTodo(input: {id: $id, date: $date}) {\n    todoUpdated {\n      ...TodoDueDate_todo\n      id\n    }\n  }\n}\n\nfragment TodoDueDateModal_todo on Todo {\n  id\n  dueDate\n}\n\nfragment TodoDueDate_todo on Todo {\n  id\n  ...TodoDueDateModal_todo\n  dueDate\n  canSchedule {\n    value\n  }\n}\n"
  }
};
})();

(node as any).hash = "6889e2d7033fa71fb827ee431b7d4ddd";

export default node;
